<template>
  <div class="footer" :class="{ 'footer-fixed' : $route.path === '/galerija' }">
    <div class="wrapper">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <img class="footer-logo" src="/static/images/phoenix.png" alt="Logo">
            <small>Fenix Bend Kula &copy; {{ year }}</small>
            <div class="footer-links">
              <a class="footer-link" href="https://sr-rs.facebook.com/pages/category/Musician-Band/Fenix-Band-Kula-462299180617615/" target="_blank">
                <i class="fa fa-facebook-f" aria-hidden="true"></i>
              </a>
              <a class="footer-link" href="https://www.instagram.com/fenixbend_kula/" target="_blank">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
              <a class="footer-link" href="https://www.youtube.com/channel/UCQfVaOAg_LjdWUCIEZaKxhA" target="_blank">
                <i class="fa fa-youtube-play" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    data() {
      return {
        year: (new Date()).getFullYear()
      }
    }
  }

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/AppFooter.vue